import { commonConfig } from '../common';
import ensighten from '../../config/common/ensighten';

const env = 'prod';

const config = {
  ...commonConfig,
  appEnv: env,
  ensighten: ensighten.getConfig(env),
  launchDarklyClientSideID: '65f38f75397645102ff117de', // PROD client-side ID
  digitalPaymentsApiBaseUrl:
    'https://api.suncorp.com.au/digital-payments-xapi/api/v1',
  cardCaptureComponentUrl:
    'https://secureccc.suncorp.com.au/card-capture-component',
  //replace with actual URLs once provided by AEM
  aemRedirectUrl: {
    AAMI: 'https://policy.aami.com.au/payonline/card-details.html',
    GIO: 'https://policy.gio.com.au/payonline/card-details.html',
    SHANNONS: 'https://policy.shannons.com.au/payonline/card-details.html',
    APIA: 'https://policy.apia.com.au/payonline/card-details.html',
    BINGLE: 'https://policy.bingle.com.au/payonline/card-details.html',
    SUNCORP: 'https://policy.suncorp.com.au/payonline/card-details.html',
    VERO: 'https://policy.vero.com.au/payonline/card-details.html',
  },
};

export default window.envConfig = Object.freeze(config);
